import axios from 'axios';

const ajaxReport = axios.create({
  baseURL: process.env.VUE_APP_REPORT_URL,
});

export default ajaxReport
